import { NgModule } from '@angular/core';
import { InjectionToken } from '@angular/core';
export var /** @type {?} */ WINDOW = new InjectionToken('WindowToken');
/**
 * @return {?}
 */
export function _window() {
    return window;
}
var WindowTokenModule = (function () {
    function WindowTokenModule() {
    }
    WindowTokenModule.decorators = [
        { type: NgModule, args: [{
                    providers: [{
                            provide: WINDOW,
                            useFactory: _window
                        }]
                },] },
    ];
    /**
     * @nocollapse
     */
    WindowTokenModule.ctorParameters = function () { return []; };
    return WindowTokenModule;
}());
export { WindowTokenModule };
function WindowTokenModule_tsickle_Closure_declarations() {
    /** @type {?} */
    WindowTokenModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    WindowTokenModule.ctorParameters;
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3048926480/src/~/ngx-clipboard/dist/~/ngx-window-token/src/index.js
// module id = PIYJ
// module chunks = 6